import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeone-protect',
  templateUrl: './homeone-protect.component.html',
  styleUrls: ['./homeone-protect.component.scss']
})
export class HomeoneProtectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
